import classNames from "classnames";
import styles from "./style.module.scss";
import CheckIcon from "assets/icons/CheckIcon";
import { DropDownItem as DropDownItemType } from "types";

type DropDownItemProps = {
  showRadioButton?: boolean;
  item: DropDownItemType;
  isSelected: boolean;
  variant?: "light";
  onSelect: (value: number) => void;
};

export const DropDownItem = ({
  item,
  variant,
  isSelected,
  showRadioButton = true,
  onSelect,
}: DropDownItemProps) => {
  const optionContainerClassnames = classNames(styles.itemContainer, {
    [styles.selectedFilter]: isSelected,
    [styles.lightBG]: isSelected && variant === "light",
  });

  return (
    <div
      className={optionContainerClassnames}
      onClick={(e: any) => {
        e.stopPropagation();
        onSelect(item.id);
      }}
      data-testid={`dropdown-item-${item.id}`}
    >
      {showRadioButton && (
        <div
          className={classNames(styles.checkbox, {
            [styles.selectedCheckbox]: isSelected,
          })}
          data-testid="dropdown-item-checkbox"
        >
          {isSelected && (
            <CheckIcon
              variant="flat"
              dataTestId="dropdown-item-checkbox-icon"
            />
          )}
        </div>
      )}
      <div
        className={classNames(styles.label, {
          [styles.selectedLabel]: isSelected,
        })}
        data-testid="dropdown-item-label"
      >
        {item.text}
      </div>
    </div>
  );
};
